<template>
	<div
		class="countdown insicht insicht--fade-in insicht--fast"
		:class="[
			bgClass,
		]"
	>
		<div
			v-if="timeDiff"
			class="countdown__time"
		>
			<div class="countdown__time-block">
				<span class="countdown__time-counter" v-html="parsedTime.d"/>
				<span class="countdown__time-label" v-html="$t('countdown.days')"/>
			</div>
			<div class="countdown__time-block">
				<span class="countdown__time-counter" v-html="parsedTime.h"/>
				<span class="countdown__time-label" v-html="$t('countdown.hours')"/>
			</div>
			<div class="countdown__time-block">
				<span class="countdown__time-counter" v-html="parsedTime.m"/>
				<span class="countdown__time-label" v-html="$t('countdown.minutes')"/>
			</div>
			<div class="countdown__time-block">
				<span class="countdown__time-counter" v-html="parsedTime.s"/>
				<span class="countdown__time-label" v-html="$t('countdown.seconds')"/>
			</div>
		</div>
		<div
			class="countdown__message"
			v-else
			v-html="message"
		>
		</div>
	</div>
</template>

<script>
import leadingZero from '@/utils/leadingZero';

export default {
	data() {
		return {
			message: this.$root.options.message || this.$t('countdown.expired'),
			rawDate: +this.$root.options.date,
			bgClass: this.$root.options.bgClass,
			// rawDate: Math.floor((Date.now() / 1000) + (1 * 60)),
			nowDate: 0,
		}
	},
	computed: {
		timeDiff() {
			return Math.max(0, this.rawDate - this.nowDate);
		},
		parsedTime() {
			return {
				d: leadingZero(Math.floor(this.timeDiff / (24 * 60 * 60))),
				h: leadingZero(Math.floor(this.timeDiff % (24 * 60 * 60) / (60 * 60))),
				m: leadingZero(Math.floor(this.timeDiff % (60 * 60) / 60)),
				s: leadingZero(Math.floor(this.timeDiff % 60)),
			}
		}
	},
	methods: {
		updateTime() {
			this.nowDate = Math.floor(Date.now() / 1000);

			if (this.timeDiff) {
				requestAnimationFrame(this.updateTime.bind(this));
			}
		}
	},
	mounted() {
		this.updateTime();
	}
}
</script>

<style>

</style>
